import { render } from "./Filters.vue?vue&type=template&id=d126844c&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"

import "./Filters.vue?vue&type=style&index=0&id=d126844c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d126844c"

export default script